import {z} from "zod/v4-mini"
import * as legacyZod from "zod"

export const engineSchema = z.union([z.literal("three"), z.literal("cycles")])
export const legacyEngineSchema = legacyZod.union([legacyZod.literal("three"), legacyZod.literal("cycles")])
export type Engine = "three" | "cycles"
export type PerEngine<Type> = Record<Engine, Type>
